module.exports = __webpack_public_path__ + "img/T6-C-rc_19.cd3b603a.png";